import React, { forwardRef, useMemo } from 'react';
import cx from 'classnames';
import '../../../../icons/ActivityIcon.js';
import '../../../../icons/AgeIcon.js';
import { ArrowDownV2 } from '../../../../icons/ArrowDownV2.js';
import '../../../../icons/ArrowDownV3.js';
import '../../../../icons/ArrowDown.js';
import '../../../../icons/ArrowLeftBig.js';
import '../../../../icons/ArrowLeft.js';
import '../../../../icons/ArrowLeft2.js';
import '../../../../icons/ArrowsDown.js';
import '../../../../icons/ArrowsUp.js';
import '../../../../icons/ArrowUpRightIcon.js';
import '../../../../icons/Baccarat.js';
import '../../../../icons/BlackJack.js';
import '../../../../icons/BookIcon.js';
import '../../../../icons/Calendar.js';
import '../../../../icons/Carts.js';
import '../../../../icons/ChartIcon.js';
import '../../../../icons/ChainIcon.js';
import '../../../../icons/CheckIcon2.js';
import '../../../../icons/CheckIcon.js';
import '../../../../icons/Checks.js';
import '../../../../icons/ChevronDown.js';
import '../../../../icons/Clock.js';
import '../../../../icons/Close.js';
import '../../../../icons/CoinsIcon.js';
import '../../../../icons/Coins.js';
import '../../../../icons/CopyIconDouble.js';
import '../../../../icons/CopyIconFill.js';
import '../../../../icons/Crown.js';
import '../../../../icons/CryptoCurrency.js';
import '../../../../icons/DiscordIcon.js';
import '../../../../icons/DiscordIconV2.js';
import '../../../../icons/Dota2.js';
import '../../../../icons/Edit.js';
import '../../../../icons/ExtendIcon.js';
import '../../../../icons/EyeOff.js';
import '../../../../icons/Eye.js';
import '../../../../icons/FacebookIconV2.js';
import '../../../../icons/FacebookIcon.js';
import '../../../../icons/FiatCurrency.js';
import '../../../../icons/FilterIcon.js';
import '../../../../icons/GameIcon.js';
import '../../../../icons/GameShows.js';
import '../../../../icons/Game.js';
import '../../../../icons/HeadPhones.js';
import '../../../../icons/HomeIcon.js';
import '../../../../icons/Horse.js';
import '../../../../icons/InfoFill.js';
import '../../../../icons/InfoIcon2.js';
import '../../../../icons/InfoIcon.js';
import '../../../../icons/InfoOutline.js';
import '../../../../icons/LevelUp.js';
import '../../../../icons/LinkIcon.js';
import '../../../../icons/Link.js';
import '../../../../icons/LiveCasino.js';
import '../../../../icons/LiveIcons2.js';
import '../../../../icons/LobbyIconV2.js';
import '../../../../icons/LobbyIcon.js';
import '../../../../icons/LogoSmallIcon.js';
import '../../../../icons/Lock.js';
import '../../../../icons/LOL.js';
import '../../../../icons/MaxIcon.js';
import '../../../../icons/MedalIcon.js';
import '../../../../icons/MedalStarIcon.js';
import '../../../../icons/MoneyBagIcon.js';
import '../../../../icons/MoneyIcon.js';
import '../../../../icons/MoneyRecive.js';
import '../../../../icons/NewTwitterIcon.js';
import '../../../../icons/OriginalsIcon.js';
import '../../../../icons/Original.js';
import '../../../../icons/PersonIcon.js';
import '../../../../icons/PhoneChatIcon.js';
import '../../../../icons/PhotoUp.js';
import '../../../../icons/PlayIcon.js';
import '../../../../icons/PlusIcon.js';
import '../../../../icons/RainIcon.js';
import '../../../../icons/RankIcon.js';
import '../../../../icons/RankinIcon.js';
import '../../../../icons/ReferalIcon.js';
import '../../../../icons/RefreshIcon.js';
import '../../../../icons/Reload.js';
import '../../../../icons/Roulette.js';
import '../../../../icons/Search2Icon.js';
import '../../../../icons/Search.js';
import '../../../../icons/SendIcon.js';
import '../../../../icons/Settings2.js';
import '../../../../icons/SettingsV3.js';
import '../../../../icons/Settings.js';
import '../../../../icons/SlotsIcon2.js';
import '../../../../icons/SlotsIcon.js';
import '../../../../icons/SmileIcon.js';
import '../../../../icons/SocialsIcon.js';
import '../../../../icons/SortIcon.js';
import '../../../../icons/SponsorshipIcon.js';
import '../../../../icons/StarFill.js';
import '../../../../icons/StarCraft.js';
import '../../../../icons/StopIcon.js';
import '../../../../icons/TableGamesIcon.js';
import '../../../../icons/TelegramIcon.js';
import '../../../../icons/TelegramIconV2.js';
import '../../../../icons/TopPicksIcon.js';
import '../../../../icons/Upload.js';
import '../../../../icons/UserMoney.js';
import '../../../../icons/UsersIconV2.js';
import '../../../../icons/UsersIcon.js';
import '../../../../icons/VerifiedIcon.js';
import '../../../../icons/WalletAddIcon.js';
import '../../../../icons/Wallet.js';
import '../../../../icons/WarningIcon.js';
import '../../../../icons/DeviceDesktop.js';
import '../../../../icons/DeviceTablet.js';
import '../../../../icons/DevicePhone.js';
import '../../../../icons/ClockOrange.js';
import '../../../../icons/CalendarOrange.js';
import '../../../../icons/OpenLinkIcon.js';
import '../../../../icons/FavoriteFill.js';
import '../../../../icons/EditorChoiceV2.js';
import '../../../../icons/ListBullet.js';
import '../../../../icons/BankIcon.js';
import '../../../../icons/ClockOrangeV2.js';
import '../../../../icons/CalendarOrangeV2.js';
import '../../../../icons/ReferralIconV2.js';
import '../../../../icons/MoneyIconV2.js';
import '../../../../icons/UsersIconV3.js';
import '../../../../icons/InfoFillV2.js';
import '../../../../icons/LockOrange.js';
import '../../../../icons/LockV2.js';
import '../../../../icons/AlertOrange.js';
import '../../../../icons/LiveSupportV2.js';
import '../../../../icons/Chat.js';
import '../../../../icons/CrossCircle.js';
import '../../../../icons/LockV3.js';
import '../../../../icons/CoinCrypto.js';
import { useWindowSize } from '../../../../../utils/hooks/useWindowSize.js';
import styles from './index.module.scss.js';

const ThumbV2 = forwardRef(
  ({
    text,
    isActive,
    thumbLabel,
    disabled,
    formType,
    image,
    roundIcon,
    value: additionalValue,
    iconForMobile,
    ...props
  }, forwardedRef) => {
    const { windowSize } = useWindowSize();
    const isAdaptive = useMemo(() => windowSize.width <= 1200, [windowSize]);
    const value = useMemo(() => {
      if (!text) return "";
      const splitted = text.split(",");
      if (splitted.length === 1)
        return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.value }, text), "\xA0", /* @__PURE__ */ React.createElement("div", { className: styles["add-value"] }, additionalValue));
      return /* @__PURE__ */ React.createElement("div", { className: styles.value }, splitted[0], " + ");
    }, [text, additionalValue]);
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        ...props,
        type: "button",
        disabled,
        className: cx(styles.box, "thumb-v2", {
          [styles["form-type"]]: formType,
          [styles["round-icon"]]: roundIcon,
          [styles.active]: isActive,
          [styles["only-icon-for-mobile"]]: isAdaptive && iconForMobile
        }),
        ref: forwardedRef
      },
      !isAdaptive || isAdaptive && !iconForMobile ? /* @__PURE__ */ React.createElement(React.Fragment, null, image && typeof image === "string" && /* @__PURE__ */ React.createElement("img", { className: styles.image, src: image, alt: image }), image && typeof image !== "string" && /* @__PURE__ */ React.createElement("div", { className: styles["image-svg"] }, image), /* @__PURE__ */ React.createElement("div", { className: styles.text }, thumbLabel), "\xA0", value, " ", /* @__PURE__ */ React.createElement(
        ArrowDownV2,
        {
          className: cx(styles["arrow-icon"], {
            [styles.active]: isActive
          })
        }
      )) : /* @__PURE__ */ React.createElement(React.Fragment, null, iconForMobile && typeof iconForMobile === "string" && /* @__PURE__ */ React.createElement(
        "img",
        {
          className: cx(styles.image, styles["icon-for-mobile"]),
          src: iconForMobile,
          alt: ""
        }
      ), iconForMobile && typeof iconForMobile !== "string" && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: cx(styles["image-svg"], styles["icon-for-mobile"])
        },
        iconForMobile
      ))
    );
  }
);
ThumbV2.displayName = "Popup.ThumbV2";

export { ThumbV2 };
//# sourceMappingURL=index.js.map
